import { render, staticRenderFns } from "./HorseWithoutPension.vue?vue&type=template&id=3db17cf8&"
import script from "./HorseWithoutPension.vue?vue&type=script&lang=js&"
export * from "./HorseWithoutPension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports